__turbopack_context__.v({
  "className": "cambay_6ce35f99-module__6gSUia__className",
  "variable": "cambay_6ce35f99-module__6gSUia__variable",
});
